import * as React from 'react';
import { useLocation } from 'react-router-dom';
import apiClient, { shouldRedirectToLogin } from '../services/api-client';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import Button from '@mui/material/Button';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import { Navigate } from 'react-router-dom';
import Grid from '@mui/material/Grid';
import ShareIcon from '@mui/icons-material/Share';

const apiUrl = process.env.REACT_APP_MGO_API_URL;

export default function ShareParksharingImage({setNavbarState, navbarState}) {
    const location = useLocation();
    const params = new URLSearchParams(location.search);
    const hashId = params.get('hash_id');
    const [redirect, setRedirect] = React.useState({ trigger: false, route: '/' });
    const [imageSrc, setImageSrc] = React.useState(null);
    const [loading, setLoading] = React.useState(true);
    const [openConfirmDialog, setOpenConfirmDialog] = React.useState(false);

    

    const shareImage = async (share = true) => {
        const config = {
            responseType: 'blob',
        };
        const blob = await apiClient.get(`parksharing/create/image/${hashId}`, { axiosConfig: config }, { action: 'fetch_parksharing_image' })
            .then(res => new Blob([res.data], { type: res.headers['content-type'] }))
            .catch(error => {
                console.log(error);
                if (shouldRedirectToLogin(error)) {
                    setRedirect({ trigger: true, route: '/login' });
                } else {
                    setRedirect({ trigger: true, route: '/parksharing' });
                }
            });
        const reader = new FileReader();
        reader.onloadend = function () {
            setImageSrc(reader.result);
            setLoading(false);
        };
        reader.readAsDataURL(blob);
        const data = {
            files: [
                new File([blob], `Parksharing_${hashId}.jpg`, {
                    type: blob.type,
                }),
            ]
        };

        if (share) {
            if (!navigator.share) return;
            try {
                await navigator.share(data);
            } catch (err) {
                console.error(err);
            }
        }
    };

    React.useEffect(() => {
        shareImage(false);
        setNavbarState({ ...navbarState, showBack: true, showOptions: false, showSearch: false});
    }, []);

    return (
        <Box sx={{ mt: 1, position: 'relative', height: '100vh' }}>
            {redirect.trigger && (
                <Navigate to={redirect.route} replace={true} />
            )}
            <Backdrop
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={loading}
            >
                <CircularProgress color="inherit" />
            </Backdrop>
            {!loading && (
                <>
                    <Box component="div" sx={{ overflow: 'auto', height: 'calc(100vh - 120px)' }}>
                        <img src={imageSrc} alt="Parksharing Image" style={{ display: 'block', marginLeft: 'auto', marginRight: 'auto', maxWidth: "99%", height: 'auto' }} />
                    </Box>
                    <Card sx={{
                        position: 'fixed',
                        py: 1,
                        bottom: 30,
                        left: '50%',
                        transform: 'translateX(-50%)',
                        width: 'calc(100% - 32px)',
                        maxWidth: '400px',
                        borderRadius: 2,
                        boxShadow: 3,
                    }}>
                        <CardActions sx={{ flexDirection: 'column', padding: 2 }}>
                            <Grid container spacing={2}>
                                <Grid item xs={12}>
                                    <Button 
                                        variant="contained" 
                                        color="secondary" 
                                        onClick={() => shareImage(true)}
                                        fullWidth
                                        size="large"
                                        startIcon={<ShareIcon />}
                                    >
                                        Compartir
                                    </Button>
                                </Grid>
                            </Grid>
                        </CardActions>
                    </Card>
                </>
            )}
        </Box>
    );
}